import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";

import * as c from "./businessPageHeader.module.scss";
import { processMarkdown } from "@utils/markdown";
import { BREAKPOINTS } from "@utils/breakpoints";
import { useWindowSize } from "@hooks/useWindowSize";
import { ContentfulCta } from "@components/shared/cta";
import PageHeaderWaveBackground from "@components/shared/waveBackground";

export const BusinessPageHeader = ({ pageHeaderData = {} }) => {
  const {
    label,
    darkBackground,
    heading,
    subheading,
    cta,
    ctaSecondary,
    backgroundImage,
    mobileBackgroundImage,
    tabletBackgroundImage,
    backgroundColor,
  } = pageHeaderData || {};

  const { width } = useWindowSize();
  const isMobile = width <= BREAKPOINTS.sm;
  const isTablet = width <= BREAKPOINTS.lg && width > BREAKPOINTS.sm;
  const isDesktop = width > BREAKPOINTS.lg;

  const subheadingText = subheading?.subheading;
  const hasCtas = cta || ctaSecondary;

  return (
    <div
      className={classNames(c.background, darkBackground && c.dark)}
      style={{
        background: backgroundColor?.value || "none",
        "--bg-color": backgroundColor?.value || "none",
      }}
    >
      {backgroundImage && isDesktop && (
        <GatsbyImage
          image={getImage(backgroundImage)}
          className={classNames(c.bg, c.backgroundImage)}
          loading="eager"
          alt={label ? `${label} - Background image` : "Background image"}
        />
      )}

      {tabletBackgroundImage && isTablet && (
        <GatsbyImage
          image={getImage(tabletBackgroundImage)}
          className={classNames(c.bg, c.backgroundImageTablet)}
          loading="eager"
          alt={label ? `${label} - Tablet Background image` : "Tablet Background image"}
        />
      )}

      {mobileBackgroundImage && isMobile && (
        <GatsbyImage
          image={getImage(mobileBackgroundImage)}
          className={classNames(c.bg, c.backgroundImageMobile)}
          loading="eager"
          alt={label ? `${label} - Mobile Background image` : "Mobile Background image"}
        />
      )}

      <section className={c.container}>
        <div className={c.businessPageRow}>
          <div className={c.header}>
            {label && <h1 className={classNames(c.eyebrow, "eyebrow")}>{label}</h1>}
            <h2 className={classNames(c.headline, "h1")} dangerouslySetInnerHTML={{ __html: heading }} />
            {subheadingText && (
              <p
                className={classNames(c.subheading, "p2")}
                dangerouslySetInnerHTML={{ __html: processMarkdown(subheadingText) }}
              />
            )}

            {hasCtas && (
              <div className={classNames(c.ctaContainer, ctaSecondary && c.ctaWrap)}>
                {cta && (
                  <ContentfulCta
                    {...cta}
                    style={cta.style?.[0] !== "Button Secondary" ? "Button Primary" : "Button Secondary"}
                  />
                )}
                {ctaSecondary && <ContentfulCta {...ctaSecondary} />}
              </div>
            )}
          </div>
        </div>
        <PageHeaderWaveBackground backgroundImage={backgroundImage || darkBackground} />
      </section>
    </div>
  );
};
